exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_wks-ext.js
// module id = 158
// module chunks = 168707334958949